import React from 'react';
import Img from "../../images/services/bc/blockchain.png";
import {Container, Row, Col} from "react-bootstrap";
import {LazyLoadImage} from "react-lazy-load-image-component";

function Buildpurpose(props) {
    return (
        <div className="services_orange_bg p-100">
            <Container>
                <Row>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto text-center order-2 order-md-1">
                        <LazyLoadImage
                            src={Img}
                            effect="blur" alt="Image" className="img-fluid"
                        />
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="services_title my-auto order-1 order-md-2">
                        <h2>Your Choice For Blockchain Development Services</h2>
                        <p>TekRevol helps SMBs and established enterprises integrate authentic and secure decentralized Blockchain app solutions for business efficiency and automation. Our Blockchain development services are well-equipped to work on major platforms, including Ethereum, Stellar, Hyperledger, Corda, Substrate, etc., to build trustworthy, lasting business ecosystems.</p>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Buildpurpose;